const MuiButton = {
  styleOverrides: {
    root: {
      color: "#E0E1E5",
    },
  },
};

export default MuiButton;
